// firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';


const firebaseConfig = {
  apiKey: "AIzaSyAQ2Jcyx45exv81h-wN6N04_drbqz__P6k",
  authDomain: "allanlostaadifound.firebaseapp.com",
  projectId: "allanlostaadifound",
  storageBucket: "allanlostaadifound.firebasestorage.app",
  messagingSenderId: "602854042198",
  appId: "1:602854042198:web:fd73b2e025d3386a7d69f7"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);